module.exports = __webpack_public_path__ + "static/media/son_of_man_AI.7f0cad83.webp";